import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {MainNavCanvasDefaultBox} from "./main-nav-canvas.default.box";
import {MainNavCanvasCasino777Box} from "./main-nav-canvas.casino777.box";
import {MainNavCanvasSIBox} from "./main-nav-canvas.si.box";

export const MainNavCanvasBox = styledByTheme(MainNavCanvasDefaultBox)
    .forCasino777(MainNavCanvasCasino777Box)
    .forSI(MainNavCanvasSIBox)
    .apply();